import React, {createContext, useContext} from 'react'
import {ModeSettingEnum} from '@colonist/types'
// eslint-disable-next-line no-restricted-imports
import {RulebookPage} from '../../../../../../code/shared/enums/RulebookEnums'
// eslint-disable-next-line no-restricted-imports
import {CA} from '../../../../../../code/client/shared/scripts/analytics/Analytics'
// eslint-disable-next-line no-restricted-imports
import {showRulebookPopup} from '../../../../../../code/client/shared/scripts/ui_rulebook/UIRulebookPopupGlobal'
import {useGameStore} from '../../../store/GameStoreContext'
import {useHasOnlyOneHumanPlayer} from '../../../store/selectors/useHasOnlyOneHumanPlayer'
import {useRequestPause} from '../../../hooks/usePause'

interface UIGameHelpRulesButtonContextProps {
    showRulesPopup: () => void
}

const UIGameHelpRulesButtonContext = createContext<UIGameHelpRulesButtonContextProps | undefined>(undefined)

export const useUIGameHelpRulesButtonContext = () => {
    const context = useContext(UIGameHelpRulesButtonContext)
    if(!context) throw new Error('UIGameHelpRulesButtonContext not found')
    return context
}

export const UIGameHelpRulesButtonProvider = ({children}: {children: React.ReactNode}) => {
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const requestPause = useRequestPause()
    const hasOnlyOneHumanPlayer = useHasOnlyOneHumanPlayer()

    const gameModeToRulebookPage = (gameMode: ModeSettingEnum): RulebookPage => {
        switch(gameMode) {
            case ModeSettingEnum.Classic56P:
            case ModeSettingEnum.Classic78P: return RulebookPage.Classic56P
            case ModeSettingEnum.Seafarers4P:
            case ModeSettingEnum.Seafarers56P: return RulebookPage.Seafarers4P
            case ModeSettingEnum.CitiesAndKnights4P:
            case ModeSettingEnum.CitiesAndKnights56P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P: return RulebookPage.CitiesAndKnights4P
            case ModeSettingEnum.ColonistRush4P: return RulebookPage.ColonistRush4P
            default: return RulebookPage.Classic4P
        }
    }

    const showRulesPopup = () => {
        if(hasOnlyOneHumanPlayer) requestPause()
        CA.sendGoogleAnalyticsEvent(CA.Category.Game, CA.Label.ClickedGameRulesButton)
        const defaultRulebookPage = gameModeToRulebookPage(modeSetting)
        showRulebookPopup(defaultRulebookPage)
    }

    return <UIGameHelpRulesButtonContext.Provider value={{
        showRulesPopup: showRulesPopup,
    }}>
        {children}
    </UIGameHelpRulesButtonContext.Provider>
}
